var styles = {"container":"bc-progression-bar__container","score-wrapper":"bc-progression-bar__score-wrapper","correct":"bc-progression-bar__correct","incorrect":"bc-progression-bar__incorrect","pending":"bc-progression-bar__pending","scoreWrapper":"bc-progression-bar__score-wrapper"};

export { styles as default };
